// Sticky bottom banner that appears once useVersionWatcher detects a
// new build on the origin. Mounted once at the root layout; renders
// nothing when there's no pending update.
//
// Deliberately doesn't auto-reload — a user might be mid-form, mid
// bulk-send, or mid-CSV-import when the new build lands and surprise-
// reloading them would lose state. Manual click only.
import { useTranslation } from 'react-i18next';
import { useVersionWatcher } from '../hooks/useVersionWatcher';

export function UpdatePrompt() {
  const { t } = useTranslation('common');
  const { updateAvailable, reload, dismiss } = useVersionWatcher();
  if (!updateAvailable) return null;
  return (
    <div className="fixed inset-x-0 bottom-4 z-[60] flex justify-center px-4 pointer-events-none">
      <div className="pointer-events-auto flex items-center gap-3 rounded-full border border-primary-200 bg-white px-4 py-2 text-xs shadow-lg ring-1 ring-black/5">
        <span aria-hidden>✨</span>
        <span className="text-gray-700">
          {t('update.message', { defaultValue: 'A new version is available.' })}
        </span>
        <button
          type="button"
          onClick={reload}
          className="rounded-full bg-primary-600 px-3 py-1 text-[11px] font-medium text-white shadow-sm hover:bg-primary-700"
        >
          {t('update.refresh', { defaultValue: 'Refresh' })}
        </button>
        <button
          type="button"
          onClick={dismiss}
          className="rounded-full px-2 py-1 text-[11px] font-medium text-gray-500 hover:bg-gray-100"
        >
          {t('update.later', { defaultValue: 'Later' })}
        </button>
      </div>
    </div>
  );
}
